export default __webpack_public_path__ + "static/media/egg-yellow.a71d1f1b.svg";